import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, PhoneCall, ArrowRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const QUESTION_KEYS = ['q1', 'q2', 'q3', 'q4'];
const SOLUTION_LINKS = {
  q3: '/blog/anionic-trash-control-atc-wet-end',
};

export const DoYouNeed = () => {
  const { t } = useLanguage();
  const cardClass = 'flex items-start gap-4 bg-emerald-600 hover:bg-emerald-700 border-2 border-emerald-600 hover:border-emerald-800 rounded-xl p-6 transition-all hover:shadow-lg text-white';

  return (
    <section className="py-20 bg-white border-y border-gray-100" data-testid="home-do-you-need">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 px-4 py-2 rounded-full mb-5 border border-emerald-200">
            <HelpCircle className="w-4 h-4" />
            <span className="text-sm font-medium">{t('ask.sub')}</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">{t('ask.title')}</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {QUESTION_KEYS.map((key, i) => {
            const to = SOLUTION_LINKS[key];
            const inner = (
              <>
                <span className="flex-shrink-0 w-9 h-9 rounded-full bg-[#D4AF37] text-gray-900 font-bold flex items-center justify-center">{i + 1}</span>
                <div className="flex-1">
                  <p className="text-xs uppercase tracking-wide text-emerald-100 font-semibold mb-1">{t('ask.prefix')}</p>
                  <p className="text-lg font-semibold text-white leading-snug">{t(`ask.${key}`)}</p>
                  {to && (
                    <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-[#D4AF37] group-hover:gap-2 transition-all">
                      {t('ask.readSolution')} <ArrowRight className="w-4 h-4" />
                    </span>
                  )}
                </div>
              </>
            );
            return to ? (
              <Link key={key} to={to} data-testid={`do-you-need-${key}`} className={`group ${cardClass}`}>{inner}</Link>
            ) : (
              <div key={key} data-testid={`do-you-need-${key}`} className={cardClass}>{inner}</div>
            );
          })}
        </div>

        <p
          data-testid="do-you-need-cta-text"
          className="mt-12 text-center text-2xl md:text-3xl font-bold text-[#8B2C3A] inline-flex w-full items-center justify-center gap-3"
        >
          <PhoneCall className="w-7 h-7 text-[#D4AF37]" />
          {t('ask.cta')}
        </p>
      </div>
    </section>
  );
};
